<template>
	<div>
		<BaseTable
			:fields="PRODUCT_STATUS_TABLE_FIELDS"
			:items="items"
			:hide-columns="['id']"
			name-route="StockBrowserSkuSingle"
			clickable-rows
			fixed
			class="table-custom"
			@onRowClick="handleRowClick"
		>
			<template #no-items-view>
				<div class="empty-table-element">
					<p class="subtitle">
						{{ $t('message.not_found_data') }}
					</p>
				</div>
			</template>
		</BaseTable>
	</div>
</template>

<script>
import { PRODUCT_STATUS_TABLE_FIELDS } from '../enums/dashboard';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'DashboardProductStatusInactiveSku',

	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			PRODUCT_STATUS_TABLE_FIELDS,
		};
	},
	methods: {
		handleRowClick(id) {
			this.$router.push({ name: ROUTER_NAME.STOCK_BROWSER_SKU_SINGLE, params: { id } });
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .table-custom {
	th, td, tr > a {
		padding-left: rem(50) !important;
	}
}

::v-deep .table-hover tbody tr:hover {
	background: none;
}
</style>
